/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import {StepType} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
import ProgramStep from "@shared/Program/ProgramStep/ProgramStep";
import DbBaseObject from '@shared/DbBaseObject.js';
import {Type} from "class-transformer";
import {classToClass} from "@qwoach/class-transformer-wrapper";
import dayjs from "dayjs";
import ClientAccessSettings from "@shared/Program/ClientAccessSettings";
import ProgramInvite from "@shared/Program/ProgramInvite";
import ProgramInfo from "@shared/Program/ProgramInfo";
import sectionDiscriminator from "@shared/Program/ProgramStep/helpers/ProgramSectionStepDiscriminator";
import CoachingSessionStep from "@shared/Program/ProgramStep/CoachingSessionStep";
import ContractProgramStep from "@shared/Program/ProgramStep/ContractProgramStep";
import TaskProgramStep from "@shared/Program/ProgramStep/TaskProgramStep";
import SectionProgramStep from "@shared/Program/ProgramStep/SectionProgramStep";
import BillingData from "@shared/Billing/BillingData";
import RecurringBillingItem from "@shared/Billing/RecurringBillingItem";



export default class CoachingProgram extends DbBaseObject{

	copiedFromId: string = ""
	name: string = ""
	description: string = ""
	programType: ProgramType = ProgramTypeEnum.ONE_ON_ONE;
	coachId: string = ""
	coachName: string = ""
	isLinkInviteEnabled: boolean = true
	inviteId: string = null
	participantsLimit: number = 1
	allowedParticipantsEmails: string[] = null
	programCategory: string = ProgramCategoryEnum.PROCESS;

	clientIdArray: string[] = []

	@Type(() => ProgramStep, sectionDiscriminator)
	programSteps: ProgramStep[] = []


	headingTitle: string = ""
	status: string = ProgramStatusEnum.NEW;
	startedOnTs: number = 0

	@Type(() => ClientAccessSettings)
	clientAccessSettings: ClientAccessSettings = new ClientAccessSettings()

	sessionTypeId: string = null

	sessionsLimit: number = 0

	@Type(() => RecurringBillingItem)
	recurringBillingItem: RecurringBillingItem = new RecurringBillingItem()

	isClientEnabled: boolean = true

	constructor(name: string = "", programType: ProgramType = ProgramTypeEnum.ONE_ON_ONE) {
		super();
		this.name = name;
		this.programType = programType;
	}

	programTypeFormatted(){
		return programTypeFormatted(this.programType);
	}

	isProcess(): boolean{
		return this.programCategory === ProgramCategoryEnum.PROCESS;
	}

	isTemplate(): boolean{
		return this.programCategory === ProgramCategoryEnum.TEMPLATE;
	}

	isOneOnOne(): boolean{
		return this.programType === ProgramTypeEnum.ONE_ON_ONE;
	}

	findParentStepForStep(step){
		let lastStep = step
		let parentStep = null
		this.findStep(step => step.id === lastStep.id, (steps, index, parentStepLocal) => {
			parentStep = parentStepLocal
		})
		return parentStep
	}

	findStepById(stepId: string): ?ProgramStep{
		let res : ?ProgramStep = null;
		this.findStep((programStep) => {
			return programStep.id == stepId;
		}, (programStepArray, index) => {
			res = programStepArray[index];
		})
		// console.log("findStepById: res = ", res)
		return res;
	}


	statusClass(){
		return ProgramStatusEnum.colorClass(this.status)
	}

	statusText(){
		return ProgramStatusEnum.formattedInvite(this.status)
	}

	completedSessionCount(){
		let res = this.findStepAll(programStep => {
			return programStep.isTypeCall() && programStep.isCallCompleted();
		}).length
		return res
	}
	upcomingSessionCount(){
		let res = this.findStepAll(programStep => {
			return programStep.isTypeCall() && !programStep.isCallCompleted();
		}).length
		return res
	}
	sessionCount(){
		let res = this.findStepAll(programStep => programStep.isTypeCall()).length
		return res
	}

	findNextSession(predicate = programStep => programStep.isTypeCall() && programStep.isSessionConfirmed() && !programStep.isInPast()){
		let allSessions = this.findStepAll(step => step.isTypeCall() && !step.isInPast())

		let sessions = this.findStepAll(predicate)
		sessions = sessions.sort((l, r) => l.confirmedTime - r.confirmedTime)
		let nextSession = sessions[0]

		console.log("findNextSession = ", nextSession)

		if(nextSession){
			console.log("findNextSession allSessions = ", allSessions)
			for(let session of allSessions){
				if(session.isSessionConfirmPending()){
					console.log("findNextSession 2 set to null")
					nextSession = session
					break
				}
				if(session.id === nextSession.id){
					break
				}
			}
		} else {
			nextSession = allSessions[0]
		}
		return nextSession
		// let sessions = this.findStepAll(predicate)
		// let steps = sessions
		// let res = steps.length > 0 ? steps[0] : null
		// console.log("findNextSession: next session = ", res)
		// if(res && res.isSessionConfirmed()){
		// 	let confirmedSessions = this.findStepAll(programStep => programStep.isTypeCall() && programStep.isSessionConfirmed())
		// 	confirmedSessions = sessions.sort((l, r) => l.confirmedTime - r.confirmedTime)
		// 	res = confirmedSessions[0]
		// }
		// console.log("findNextSession: next session 2 = ", res)
		// return res
	}

	findLastSession(predicate = programStep => programStep.isTypeCall()){
		let sessions = this.findStepAll(predicate)
		let steps = sessions.sort((l, r) => l.confirmedTime - r.confirmedTime)
		let res = steps.length > 0 ? steps[steps.length - 1] : null
		return res
	}

	findNextRecurringSession(){
		let res = this.findNextSession(programStep => {
			return programStep.isRecurring && programStep.isTypeCall() && !programStep.isCallCompleted()
		})
		return res
	}
	findLastRecurringSession(){
		let res = this.findLastSession(programStep => programStep.isRecurring && programStep.isTypeCall())
		return res
	}
	nextSessionFormatted(currentUserId: string){
		let nextSession = this.findNextSession()
		// let hasSessions = this.findStep(step => step.isTypeCall())

		console.log("nextSessionFormatted: nextSession = ", nextSession)
		let nextSessionFormatted = "no sessions";

		if(!nextSession) {
			return nextSessionFormatted
		}

		if(nextSession.isCallConfirmed()){
			nextSessionFormatted = nextSession.confirmedTimeFormatted("[at] hh:mma [on] ddd, MMM DD")
		}else {
			if(nextSession.doWeNeedToConfirm(currentUserId)){
				nextSessionFormatted = "confirm time"
			} else {
				nextSessionFormatted = "not scheduled"
			}
		}

		return nextSessionFormatted;
	}

	nextSessionClass(currentUserId: string, currentUserEmail: string){
		let res = this.findNextSession();
		// 	.sort((l, r) => {
		// 	return l.confirmedTime - r.confirmedTime;
		// })[0]



		let nextSessionClass = "";

		if(res && res.needsConfirmation(currentUserEmail)){
			if(res.doWeNeedToConfirm(currentUserId)){
				nextSessionClass = "text-warning"
			} else {
				nextSessionClass = "text-warning"
			}
		}
		console.log("nextSessionClass: res = ", res)

		return nextSessionClass;
	}

	globalGoalFormatted(){

	}

	currentGoalFormatted(){
		console.log("currentGoalFormatted: this = ", this)
		let goal = this.findFirstUnsolvedTask()
		let goalText = "no next task"
		if(goal){
			goalText = goal.name;
		}
		return goalText;
	}

	startedOnFormatted(){
		if(this.startedOnTs > 0){
			return "Started on " + dayjs(this.startedOnTs).format("MMMM DD YYYY")
		}
		return ""
	}

	findFirstUnsolvedTask(){
		let res : ?ProgramStep = null;
		this.findStep((programStep) => {
			// console.log("findFirstUnsolvedTask: programStep = ", programStep)
			return programStep.isTypeTask() && programStep.isCompleted && !programStep.isCompleted();
		}, (programStepArray, index) => {
			res = programStepArray[index];
		})
		// console.log("findStepById: res = ", res)
		return res;

	}

	setStepById(stepId: string, programStep: ProgramStep): boolean{
		let res = false;
		this.findStep((programStep) => {
			return programStep.id === stepId;
		}, (programStepArray, index) => {
			programStepArray[index] = programStep
			res = true;
		})
		// console.log("findStepById: res = ", res)
		return res;
	}

	deleteStepById(stepId: string, programStep: ProgramStep): boolean{
		let res = false;
		this.findStep((programStep) => {
			return programStep.id == stepId;
		}, (programStepArray, index) => {
			programStepArray.splice(index, 1)
			res = true;
		})
		console.log("deleteStepById: res = ", res)
		return res;
	}


	findStep(predicateFunction: (programStep: ProgramStep) => boolean, callback: (programStepArray: ProgramStep[], index: number, parentStep: ProgramStep) => any){
		return this.findStepRecursion(this.programSteps, predicateFunction, callback, null)
	}

	findStepRecursion(programSteps: ProgramStep[], predicateFunction: (programStep: ProgramStep) => boolean, callback: (programStepArray: ProgramStep[], index: number, parentStep: ProgramStep) => any, parentStep: ProgramStep){
		for(let i = 0; i < programSteps.length; ++i){
			let step = programSteps[i];
			if(predicateFunction(step)){
				if(callback) callback(programSteps, i, parentStep)
				return true;
			}
			let res = this.findStepRecursion(step.subStepList, predicateFunction, callback, step)
			if(res){
				return res;
			}
		}
		return false;
	}



	findStepAll(predicateFunction: (programStep: ProgramStep) => boolean, programSteps = this.programSteps){
		return this.findStepRecursionAll(programSteps, predicateFunction)
	}

	findStepRecursionAll(programSteps: ProgramStep[], predicateFunction: (programStep: ProgramStep) => boolean): ProgramStep[]{
		let res : ProgramStep[] = [];
		for(let i = 0; i < programSteps.length; ++i){
			let step = programSteps[i];
			if(predicateFunction(step)){
				res.push(step)
			}
			let resLocal = this.findStepRecursionAll(step.subStepList, predicateFunction)
			res = [...res, ...resLocal]
		}
		return res;
	}



	getSection(index){
		return this.programSteps[index]
	}

	addSection(section) {
		this.programSteps.push(section);
		return this.programSteps.length - 1;
	}


	addProgramStep(programStep: ProgramStep, sectionIndex: number){
		this.programSteps[sectionIndex].addProgramStep(programStep);
	}


	static createStubCoachingProgram(name: string, programType: ProgramType, coachId: string = ""){

		let program = new CoachingProgram(name, programType)

		let w1call = new CoachingSessionStep()
		w1call.suggestedTimeOwnerUid = coachId;

		let w1task = new ContractProgramStep()

		let w1task2 = new TaskProgramStep()
		w1task2.name = "Welcome materials";

		let w2call = new CoachingSessionStep()
		w2call.suggestedTimeOwnerUid = coachId;

		let w2task = new TaskProgramStep()
		w2task.stepType = StepType.TASK
		w2task.name = "Example task: list your goals";

		program.programSteps = [
			new SectionProgramStep("Welcome", "", [
				w1task,
				w1task2
			]),
			new SectionProgramStep("Session 1", "", [
				w2task
			]),
		]
		return program;
	}

	findAllRecurringSessionSteps(programSteps){
		return this.findStepAll(step => !!step.isRecurring, programSteps)
	}

	hasActiveRecurringSession(){
		let res = false
		let recurringSteps = this.findAllRecurringSessionSteps()
		let lastStepRecurMasterId = null
		for(let i = recurringSteps.length - 1; i >= 0; --i){
			let step = recurringSteps[i];
			if(!step.isCallCompleted() && step.recurMasterId !== lastStepRecurMasterId){
				res |= step.hasMoreRecurringEvents
				lastStepRecurMasterId = step.recurMasterId
			}
		}
		return res
	}

	hasNotCompletedRecurringSession(){
		let res = false
		let recurringSteps = this.findAllRecurringSessionSteps()
		let lastStepRecurMasterId = null
		for(let i = recurringSteps.length - 1; i >= 0; --i){
			let step = recurringSteps[i];
			if(!step.isCallCompleted() && step.recurMasterId !== lastStepRecurMasterId){
				return true
			}
		}
		return res
	}

	getHeadingTitle(){

		let isOneOnOne = this.isOneOnOne();
		if(isOneOnOne && this.headingTitle && !this.oneOnOneClientName){
			this.oneOnOneClientName = this.headingTitle
		}
		let participants = this.clientIdArray.length == 1 ? "participant" : "participants";
		let groupHeading = "" + this.clientIdArray.length + " " + participants;

		let oneOnOneHeading = this.clientIdArray.length > 0 ? this.oneOnOneClientName : "(invite a client)"

		let heading = isOneOnOne ? oneOnOneHeading : groupHeading;

		return heading || this.headingTitle;
	}

	createNewTemplate(){
		return this.copy(ProgramCategoryEnum.TEMPLATE);
	}

	createNewProcess(){
		return this.copy(ProgramCategoryEnum.PROCESS);
	}

	copy(programCategory){
		let process = classToClass(this)
		process.programCategory = programCategory
		process.reset()
		return process;
	}

	reset() {
		this.copiedFromId = this.id
		this.id = null
		this.status = ProgramStatusEnum.NEW;
		this.clientIdArray = []
		this.createdAt = new Date().getTime()
		let heading = this.isOneOnOne() ? "(invite a client)" : "0 participants";
		this.headingTitle = heading;
		this.findStepAll(programStep => programStep.reset())
	}


	addClient(clientProfile){
		this.clientIdArray.push(clientProfile.clientId)
		if(this.status === ProgramStatusEnum.NEW || this.status === ProgramStatusEnum.PENDING){
			this.status = ProgramStatusEnum.ACTIVE;
			this.startedOnTs = new Date().getTime()
		}
		this.syncProgramHeading(clientProfile)
	}

	onInviteSent(clientProfile){
		if(this.status === ProgramStatusEnum.NEW){
			this.status = ProgramStatusEnum.PENDING;
			this.syncProgramHeading(clientProfile)
		}
	}

	syncProgramHeading(clientProfile){
		let isGroup = this.programType === ProgramTypeEnum.GROUP;
		let headingTitle = clientProfile.name
		if(isGroup){
			let clientsCount = this.clientIdArray.length
			let participants = clientsCount === 1 ? "participant" : "participants";
			let groupHeading = "" + clientsCount + " " + participants;
			headingTitle = groupHeading;
		}

		this.headingTitle = headingTitle
	}


	createProgramInvite(){
		let programInvite = new ProgramInvite()
		programInvite.coachId = this.coachId
		programInvite.programId = this.id
		programInvite.participantsLimit = this.participantsLimit
		// programInvite.generateInviteLink(clientProfile.id);

		return programInvite
	}

	createProgramInfo(){
		let programInfo = new ProgramInfo()
		programInfo.programName = this.name;
		programInfo.programDescription = this.description;
		programInfo.programId = this.id;
		programInfo.coachId = this.coachId;
		programInfo.status = this.status;

		return programInfo
	}


	expandFirstStepsFor(userId, stepsCount){
		if(!this.programSteps){
			return
		}
		let count = Math.min(stepsCount, this.programSteps.length)
		for(let i = 0; i < count; ++i){
			this.programSteps[i].expandItemForOwnerId(userId)
		}
	}

	hasClient(clientProfile){
		for(let clientId of this.clientIdArray){
			if(clientId === clientProfile.id){
				return true
			}
		}
		return false
	}

	canAcceptMoreParticipants(){
		return !this.participantsLimit || this.clientIdArray.length < this.participantsLimit
	}

	canAcceptParticipantByEmail(participantEmail){
		return !this.allowedParticipantsEmails || this.allowedParticipantsEmails.includes(participantEmail)
	}

	createBillingData(){
		let billingData = new BillingData()
		billingData.programId = this.id
		return billingData
	}

	syncPaymentLockerFromBillingData(billingData, invoices = []){
		console.log("syncPaymentLockerFromBillingData: invoices = ", invoices, ", billingData = ", billingData)
		let programItem = this
		let changed = false
		let before1, before2
		programItem.programSteps.forEach(stepItem => {
			let billingItem = billingData.findBillingItemByMilestoneSectionId(stepItem.id)
			// console.log("syncPaymentLockerFromBillingData: billingItem = ", billingItem)
			before1 = stepItem.lockerState.hasPaymentLocker
			stepItem.lockerState.hasPaymentLocker = false
			stepItem.lockerState.isLockedByPayment = false
			stepItem.lockerState.billingDataId = null
			stepItem.lockerState.invoiceGroupId = null
			stepItem.lockerState.billingItemIds = []

			if(billingItem){
				stepItem.lockerState.hasPaymentLocker = true
				before2 = stepItem.lockerState.isLockedByPayment
				stepItem.lockerState.isLockedByPayment = true
				stepItem.lockerState.billingDataId = billingData.id
				stepItem.lockerState.billingItemIds = [billingItem.id]

				if(billingItem.amount !== stepItem.lockerState.paymentAmount){
					changed = true
				}
				stepItem.lockerState.paymentAmount = billingItem.amount
				invoices.forEach(invoiceGroup => {

					let invoice = invoiceGroup.findInvoiceByBillingItemId(billingItem.id)
					console.log("syncPaymentLockerFromBillingData: invoiceGroup = ", invoiceGroup, ", invoice = ", invoice)
					if(invoice){
						stepItem.lockerState.invoiceGroupId = invoiceGroup.id
					}

					if(invoice && invoice.isPaid()){
						stepItem.lockerState.isLockedByPayment = false
					}
				})
				if(before2 !== stepItem.lockerState.isLockedByPayment){
					changed = true
				}
			}
			if(before1 !== stepItem.lockerState.hasPaymentLocker){
				changed = true
			}
		})

		return changed
	}

	analyticsProps(){
		return {
			program_id: this.id,
			program_name: this.name,
		}
	}


}



export const ProgramStatusEnum = {
	NEW: 'NEW',
	PENDING: 'PENDING',
	ACTIVE: 'ACTIVE',
	ARCHIVED: 'ARCHIVED',
	DISABLED: 'DISABLED',

	formatted(status: string): string {
		switch (status) {
			case ProgramStatusEnum.NEW:
				return "New";
			case ProgramStatusEnum.PENDING:
				return "Pending";
			case ProgramStatusEnum.ACTIVE:
				return "Active";
			case ProgramStatusEnum.ARCHIVED:
				return "Archived";
			case ProgramStatusEnum.DISABLED:
				return "Disabled";
		}
		return ""
	},

	formattedInvite(status: string): string {
		switch (status) {
			case ProgramStatusEnum.NEW:
				return "New";
			case ProgramStatusEnum.PENDING:
				return "Invite pending";
			case ProgramStatusEnum.ACTIVE:
				return "Active";
			case ProgramStatusEnum.ARCHIVED:
				return "Archived";
		}
		return ""
	},

	colorClass(status: string): string {
		switch (status) {
			case ProgramStatusEnum.NEW:
				return "badge-info";
			case ProgramStatusEnum.PENDING:
				return "badge-warning";
			case ProgramStatusEnum.ACTIVE:
				return "badge-success";
			case ProgramStatusEnum.ARCHIVED:
				return "badge-secondary";
			case ProgramStatusEnum.DISABLED:
				return "badge-danger";
		}
		return "Not set"
	}
}



export const ProgramTypeEnum = {
	ONE_ON_ONE: 'ONE_ON_ONE',
	GROUP: 'GROUP',
}
type ProgramType = $Keys<typeof ProgramTypeEnum>

export const ProgramCategoryEnum = {
	PROCESS: 'PROCESS',
	TEMPLATE: 'TEMPLATE',
}

export const programTypeFormatted = function(programType: ProgramType):string{
	switch(programType){
		default:
			return "One on one"
		case ProgramTypeEnum.GROUP:
			return "Group"
	}
}
